import { gql } from '@apollo/client'

export const SEND_VERIFICATION_CODE = gql`
  mutation SendVerificationCode($phoneNumber: String!) {
    sendVerificationCode(input: { phoneNumber: $phoneNumber }) {
      ... on PhoneVerificationSuccess {
        ok
      }
      ... on PhoneVerificationFailure {
        errorMessage
      }
    }
  }
`

export const CHECK_VERIFICATION_CODE = gql`
  mutation CheckVerificationCode($phoneNumber: String!, $code: String!, $optIn: Boolean) {
    checkVerificationCode(input: { phoneNumber: $phoneNumber, code: $code, optIn: $optIn }) {
      ... on PhoneVerificationSuccess {
        ok
      }
      ... on PhoneVerificationFailure {
        errorMessage
      }
    }
  }
`

export const GENERATE_REFERRAL_CODE = gql`
  mutation GenerateReferralCode {
    generateReferralCode(input: {}) {
      __typename
      ... on UserReferralNode {
        id
        code
      }
      ... on MutationError {
        errorMessage
      }
    }
  }
`

export const UPDATE_NOTIFICATIONS = gql`
  mutation UpdateUserNotifications($notifyOnNewWorks: Boolean!) {
    updateUserNotifications(input: { notifyOnNewWorks: $notifyOnNewWorks }) {
      user {
        id
        notifyOnNewWorks
      }
    }
  }
`

export const SUBMIT_FOR_GIVEAWAY = gql`
  mutation SubmitForGiveaway($input: SubmitForGiveawayInput!) {
    submitForGiveaway(input: $input) {
      ... on SubmitForGiveawaySuccess {
        success
      }
      ... on SubmitForGiveawayFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`
export const ADD_OR_UPDATE_CONTACT_LIST = gql`
  mutation AddOrUpdateContactList($listNames: [String!], $listIds: [String!], $data: ContactData!) {
    addOrUpdateContactList(input: { listNames: $listNames, listIds: $listIds, data: [$data] }) {
      ... on ContactMutationSuccess {
        success
      }
      ... on ContactMutationFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`

export const FOLLOW_VENUE = gql`
  mutation FollowVenue($id: ID!) {
    followVenue(input: { id: $id }) {
      ... on FollowVenueSuccess {
        venue {
          id
        }
      }
      ... on FollowVenueFailure {
        errorMessage
      }
    }
  }
`

export const UNFOLLOW_VENUE = gql`
  mutation UnfollowVenue($id: ID!) {
    unfollowVenue(input: { id: $id }) {
      ... on FollowVenueSuccess {
        venue {
          id
        }
      }
      ... on FollowVenueFailure {
        errorMessage
      }
    }
  }
`

export const FINISH_ACCOUNT = gql`
  mutation FinishGuestAccount($input: FinishGuestAccountInput!) {
    finishGuestAccount(input: $input) {
      ... on SignupSuccess {
        user {
          id
          pk
          firstName
          lastName
          email
          phoneNumber
          locationCountry
        }
      }
      ... on SignupFailure {
        errorMessage
        fieldsErrors {
          field
          messages
        }
      }
    }
  }
`
